import { useEffect, useState } from "react";

const CompanySelector = () => {
  const [selectedCompany, setSelectedCompany] = useState(localStorage.getItem("active_company") || "");
  const [companyList, setCompanyList] = useState([]);

  useEffect(() => {
    const storedCompanies = JSON.parse(localStorage.getItem("companyList") || "[]");
    setCompanyList(storedCompanies);
  }, []);

  const handleChange = (e) => {
    const companyId = e.target.value;
    setSelectedCompany(companyId);
    localStorage.setItem("active_company", companyId);
    window.dispatchEvent(new Event("companyChanged")); // ✅ trigger permission refresh
  };

  return (
    <select
      value={selectedCompany}
      onChange={handleChange}
      className="ml-2 text-sm bg-transparent text-gray-100 rounded px-2 py-1 focus:outline-none"
    >
      {companyList.map((company) => (
        <option key={company.infoID} value={company.infoID}>
          {company.companyName}
        </option>
      ))}
    </select>
  );
};

export default CompanySelector;
